module.exports = __webpack_public_path__ + "media/images/icon-delivery-d0a312ba.svg";